export const LAST_HORIZON_CATEGORIES = [
  { value: "MOBILE", label: "Mobile" },
  { value: "DSLR_MIRRORLESS", label: "DSLR / Mirrorless" },
];

export const LAST_HORIZON_STEPS = ["Profile", "Declarations", "Payment", "Profile Photo", "Media", "Review & Submit"];

export const fmtINR = (n) => `\u20b9${Number(n || 0).toLocaleString("en-IN")}`;
